import { TriangleAlert } from 'lucide-react'
import { InterviewInsightCard } from './InterviewInsightCard'
import {
  QuestionsGrid,
  EmptyState,
  EmptyStateTitle,
  EmptyStateText,
  MismatchBanner,
} from '../../../survey/pages/SurveyInsightsPageStyles'
import type { ReconciledInterviewQuestion } from '../../pages/interviewInsightsUtils'

export interface InterviewAllResponsesTabProps {
  reconciledQuestions: ReconciledInterviewQuestion[]
  noteCount: number
  hasMismatch: boolean
  isPrinting: boolean
}

export function InterviewAllResponsesTab({
  reconciledQuestions,
  noteCount,
  hasMismatch,
  isPrinting,
}: InterviewAllResponsesTabProps) {
  return (
    <>
      {hasMismatch && (
        <MismatchBanner>
          <TriangleAlert size={15} style={{ flexShrink: 0, marginTop: 1 }} />
          <span>
            Some notes were recorded before the interview questions were edited. Those notes may not
            align with the current question order — mismatched answers are excluded from each chart.
          </span>
        </MismatchBanner>
      )}
      <QuestionsGrid>
        {noteCount === 0 ? (
          <EmptyState>
            <EmptyStateTitle>No interviews recorded yet</EmptyStateTitle>
            <EmptyStateText>
              Click "Record" on the interview node to start your first interview.
            </EmptyStateText>
          </EmptyState>
        ) : (
          reconciledQuestions.map((question, i) => (
            <InterviewInsightCard
              key={question.id ?? i}
              question={question}
              questionIndex={i}
              answers={question.answers}
              isPrinting={isPrinting}
              isDeleted={question.isDeleted}
            />
          ))
        )}
      </QuestionsGrid>
    </>
  )
}
